import request from '@/router/axios'
import env from '@/config/env'


export const list = (data) => {
  return request({
    url: env.ferryUrl + '/driverHealthCode/page',
    method: 'post',
    data: data
  })
}

//审核
export const toExamine = (data) => {
  return request({
    url: env.ferryUrl + '/driverHealthCode/check?'+data,
    method: 'post',
    data: {}//data
  })
}

